import React from 'react';
import Props from '../../Components/Props';
import FormikFields from 'components/FormikFields';
import JSXCode from '../../Components/JSXCode';
import { Form, Formik } from 'formik';
import { CommonIcons } from 'components/Icons';

const TabCheckbox = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='component:TabCheckbox'>
      <Formik initialValues={{ isDeveloper: false }} onSubmit={() => {}}>
        {({ values }) => {
          return (
            <Form>
              <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>
              <FormikFields.Checkbox name='isDeveloper' label='Is Developer' />
            </Form>
          );
        }}
      </Formik>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<Formik initialValues={{ isDeveloper: false }} onSubmit={() => {}}>
{() => {
    return (
    <Form>
        <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>
        <FormikFields.Checkbox name='isDeveloper' label='Is Developer' />
    </Form>
    );
}}
</Formik>
`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'name',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'label',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'placeholder',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'afterOnChange',
            type: '(event) => void',
            default: 'undefined',
          },
          { prop: 'classNameContainer', type: 'string', default: 'undefined' },
          { prop: 'positionLabel', type: '"left" | "right"', default: '"left"' },
          {
            prop: 'disabled',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'defaultChecked',
            type: 'boolean',
            default: 'false',
          },
        ]}
      />
    </div>
  );
};

export default TabCheckbox;
